import { httpGet, httpPost, httpPostWithNoCommit } from '../utils'

export default {
  getRobotCaptcha (cb) {
    httpGet('/auth/captcha/get', cb)
  },
  getRegisterTeamCount (cb) {
    httpGet('/register/count', cb)
  },
  checkRobotCaptcha (cb, captcha) {
    httpPost('/auth/captcha/check', captcha, cb)
  },
  getSmsCaptchaLogin (cb, phoneNumber, smsType, captcha) {
    httpGet(`/auth/captcha_sms/login?mobile=${phoneNumber}&type=${smsType}&geetest_challenge=${captcha['geetest_challenge']}&geetest_seccode=${captcha['geetest_seccode']}&geetest_validate=${captcha['geetest_validate']}`, cb)
  },
  getSmsCaptchaReg (cb, phoneNumber, smsType, captcha) {
    httpGet(`/auth/captcha_sms/register?mobile=${phoneNumber}&type=${smsType}&geetest_challenge=${captcha['geetest_challenge']}&geetest_seccode=${captcha['geetest_seccode']}&geetest_validate=${captcha['geetest_validate']}`, cb)
  },
  login (cb, { phoneNumber, smsCaptcha, teamId }) {
    const body = {
      credential: phoneNumber,
      'sms_captcha': smsCaptcha
    }
    if (teamId) {
      body['team_id'] = teamId
    }
    httpPost('/auth/attempt', body, cb)
  },
  loginByMail (cb, { mail, password, teamId }) {
    const body = {
      credential: mail,
      password
    }
    if (teamId) {
      body['team_id'] = teamId
    }
    httpPost('/auth/attempt', body, cb)
  },
  logout (cb) {
    httpPost('/auth/logout', {}, cb)
  },
  /**
   * @param {string} type - 'login' or 'register'?
   */
  checkSmsCaptcha (cb, { type, smsCaptcha }) {
    httpPost('/auth/captcha_sms/check', {
      type,
      'sms_captcha': smsCaptcha
    }, cb)
  },
  register (cb, { email, smsCaptcha, mobile, name, username, password, passwordConfirm }) {
    httpPost('/auth/register', {
      email,
      mobile,
      name,
      username,
      password,
      'sms_captcha': smsCaptcha,
      'password_confirmation': passwordConfirm
    }, cb)
  },
  getUser (cb) {
    httpGet(`/auth/user`, cb)
  },

  saveLxpwd (body, cb) {
    httpPostWithNoCommit('/api/team/complete_team_info', body, cb)
  }
}



// WEBPACK FOOTER //
// ./src/api/lxm/login.js